import {React, useState, useEffect} from 'react'
import logo from '../images/logo.png'
import { Navbar, Dropdown, Avatar } from 'flowbite-react';
import { auth } from '../firebase/FirebaseConfig';
import { useNavigate } from 'react-router';
import { getUserInfo } from '../firebase/FirebaseManagement';
export default function  (props) {



    
    const navigate = useNavigate();
    const {account, setAccount} = props;
    
    const logoutUser = async () => {
        try {
          await auth.signOut();
          // Perform any additional actions or UI updates after successful logout
          console.log('User logged out successfully');
          localStorage.clear()
         
          navigate("./")
        } catch (error) {
          console.log('Logout failed:', error);
          // Handle the error appropriately
        }
      };
  return (
    <div className='drop-shadow-md mb-10'>
        <Navbar fluid rounded>
      <Navbar.Brand href="/">
        <img src={logo} className="mr-3 h-6 sm:h-9" alt="Flowbite React Logo" />
        <h1 className='text-2xl'>Rex<span className="span-titles">Ride</span> </h1>
      </Navbar.Brand>
      <div className="flex md:order-2">
        <Dropdown
          arrowIcon={false}
          inline
          label={
            <Avatar alt="User settings" img={account?.file} rounded />
          }
        >
          {account !== undefined && <div>
                <Dropdown.Header>
                <span className="block text-sm">{`${account?.firstName} ${account?.lastName}`}</span>
                <span className="block truncate text-sm font-medium">{account?.email}</span>
            </Dropdown.Header>
            {/* <Dropdown.Item>Dashboard</Dropdown.Item>
            <Dropdown.Item>Settings</Dropdown.Item>
            <Dropdown.Item>Earnings</Dropdown.Item> */}
       
            <Dropdown.Item onClick={()=> {logoutUser()}}>Sign out</Dropdown.Item>
            </div>}
            {account === undefined && <div>
                <Dropdown.Item onClick={()=> navigate("/login")}>Sign in</Dropdown.Item>
            <Dropdown.Item onClick={()=> navigate("/signup")}>Create Account</Dropdown.Item>
            </div>
            }
        </Dropdown>
        <Navbar.Toggle />
      </div>
      <Navbar.Collapse>
        <Navbar.Link href="/">
          Home
        </Navbar.Link>
        <Navbar.Link href="/myrides">My Rex Rides</Navbar.Link>
        <Navbar.Link href="/allrexrides">Search Rides</Navbar.Link>
        <Navbar.Link href="/create-ride">Create Ride</Navbar.Link>
        <Navbar.Link href="/aboutus">About Us</Navbar.Link>
        
      </Navbar.Collapse>
    </Navbar>

        
    </div>
  )
}
